import styled, {css} from "styled-components";
import {IBannerContainerBoxProps} from "../banner-container/banner-container.default.box";

export const EmptyBannerContainerBox = styled.div<IBannerContainerBoxProps>`
    width: 100%;
    ${props => props.minHeight && css`
        min-height: ${props.minHeight};
    `};
`;
